module.exports = __webpack_public_path__ + "img/15.70ac1dfe.png";